import { forwardRef } from "react";
import { Form, Settings, SettingsItem, Select } from "ui";
import { MenuItem } from "@mui/material";
import NetsModel from "./types/NetsModel";
import FormRef from "../types/FormRef";

type NetsUpdateFormProps = {
    data: NetsModel;
    errors: any;
    loading: boolean;
    onSubmit: (data: NetsModel) => void;
};

const NetsUpdateForm = forwardRef<FormRef, NetsUpdateFormProps>(
    ({ data, errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={data}
                errors={errors}
                fields={{
                    environment: { default: "production" },
                }}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                {(context: any) => {
                    return (
                        <>
                            <Settings>
                                <SettingsItem label="Environment">
                                    <Select
                                        fullWidth
                                        id="environment"
                                        margin="none"
                                    >
                                        <MenuItem value="test">Test</MenuItem>
                                        <MenuItem value="production">
                                            Production
                                        </MenuItem>
                                    </Select>
                                </SettingsItem>
                            </Settings>
                        </>
                    );
                }}
            </Form>
        );
    },
);

export default NetsUpdateForm;
